/**
 * Shared behaviour for the contact drawer's filter chip rows.
 *
 * Both the Activities and PMS rows are additive filters over one merged stream,
 * so they toggle the same way. Keeping the rule here stops the two rows drifting
 * into subtly different behaviour.
 */

/**
 * At least one chip stays selected. An empty stream is a dead end that tells the
 * reader nothing, so the last active chip does not turn off.
 */
export function toggleChipSelection<T>(selected: T[], value: T): T[] {
  if (!selected.includes(value)) return [...selected, value]
  if (selected.length === 1) return selected
  return selected.filter((current) => current !== value)
}
